import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, LazyLoadEvent, Message, SelectItem } from 'primeng/api';
import { DataTable } from 'primeng/primeng';
import { SubscriptionPlan } from '../../../models/inModels/Subscription';
import { SubscriptionPlanService as SubscriptionService } from '../../../services/subscription.service';

@Component({
	selector: 'app-subscription-plans',
	templateUrl: './subscription-plans.component.html',
	styleUrls: ['./subscription-plans.component.css']
})
export class SubscriptionPlansComponent {
	items: SubscriptionPlan[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	constructor(
		private service: SubscriptionService,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
	}
	changeRows(event): void {
		this.load(this.rowEvent);
	}
	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.service.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(plan: SubscriptionPlan) {
		this.router.navigate(['subscriptions/plans/edit', plan.Id]);
	}

	delete(plan: SubscriptionPlan) {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete <strong>${plan.Name}</strong>?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.service.delete(plan.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/subscriptions/plans/subscription-plans.component.ts